import { Component, HostListener, OnInit } from '@angular/core';

import { detectBody } from 'src/app/shared/app.helpers';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';

declare var jQuery: any;

@Component({
  selector: 'app-basic-layout',
  templateUrl: 'basicLayout.template.html',
})
export class BasicLayoutComponent implements OnInit {

  menuView = false;
  width = document.querySelector('body').offsetWidth;

  public ngOnInit(): any {
    detectBody();

    if (this.width > 1445) {
      this.menuView = true;
    }
    
    EventSharedService.get('menuView').subscribe((res) => {
      this.menuView = !this.menuView;
    })
  }

  @HostListener('window:resize') onResize() {
    detectBody();
  }
}
